<div class="dd-filter sidebar-menu-filter">
  <div class="dd-filter__scroll">
    <div class="dd-filter__close">
      <sk-button size="sm"
                 data-test="module-filter-setVisibility-button"
                 appearance="icon"
                 (click)="setFilterVisibility(false)">
        <ng-template buttonPrefix>
          <i class="icon fal fa-2x fa-times"></i>
        </ng-template>
      </sk-button>

    </div>
    <div class="dd-filter__ttl">{{'label.Filter' | translate}}</div>
    <div class="dd-filter__fltr">
      <ng-container *ngTemplateOutlet="formTemplate;context:ctx"></ng-container>
    </div>
  </div>
  <div class="dd-filter__bottom">
    <sk-button
               appearance="solid"
               data-test="module-filter-applyFilter-button"
               color="primary"
               (click)="applyFilter()"
               [disabled]="isFilterNotValid"
               [label]="'label.ApplyFilter' | translate">
    </sk-button>
    <sk-button
               appearance="outlined"
               data-test="module-filter-openSaveFilterModal-button"
               [color]="'primary'"
               (click)="openSaveFilterModal()"
               [disabled]="isFilterNotValid"
               [label]="'label.SaveFilter' | translate">
    </sk-button>
    <sk-button
               appearance="outlined"
               data-test="module-filter-resetFilterToDefault-button"
               [color]="'primary'"
               (click)="resetFilterToDefault()"
               [matTooltip]="'label.ResetFilter' | translate"
               [label]="'label.Reset' | translate">
    </sk-button>
  </div>
</div>
